import { useState } from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import ListSubheader from "@mui/material/ListSubheader";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { confirmAlert } from "react-confirm-alert";
import { useSelector } from "react-redux";
import TurmaTableSelectRedux from "../Turma/TurmaTableSelectRedux";
import TurmaProfileRedux from "../Turma/TurmaProfileRedux";
import { ADMIN, COORDENADOR } from "../Usuario/Perfil";
import { gerarResultadoFinalPorInstituicao, gerarResultadoFinalPorTurma } from "./api-aluno-turma";
import { gerarMediaFinalPorInstituicao, gerarMediaFinalPorTurma } from "../NotaBimestre/api-nota-bimestre";
import { errorMessage, successMessage } from "../../util/ConfirmAlertUtil";
import Container from "../UI/Container";
import AlunoTurmaFormContainer from "./AlunoTurmaFormContainer";
import AlunoTurmaTable from "./AlunoTurmaTable";

const GRUPOS_ACOES = [
  {
    titulo: "Média Final",
    acoes: [
      { label: "Gerar para a Turma", message: "Gerar Média Final para a turma?", request: (t) => gerarMediaFinalPorTurma(t.codigo) },
      { label: "Gerar para a Instituição", message: "Gerar Média Final para toda a instituição?", request: () => gerarMediaFinalPorInstituicao() },
    ],
  },
  {
    titulo: "Resultado Final",
    acoes: [
      { label: "Gerar para a Turma", message: "Gerar Resultado Final para a turma?", request: (t) => gerarResultadoFinalPorTurma(t.codigo) },
      { label: "Gerar para a Instituição", message: "Gerar Resultado Final para toda a instituição?", request: () => gerarResultadoFinalPorInstituicao() },
    ],
  },
];

export default function AlunoTurmaContainer() {
  const turma = useSelector((state) => state.turma);
  const alunoTurma = useSelector((state) => state.alunoTurma);
  const user = useSelector((state) => state.usuario);
  const isGestor = user?.perfil === ADMIN || user?.perfil === COORDENADOR;
  const [anchorEl, setAnchorEl] = useState(null);

  const handleAcao = (acao) => {
    setAnchorEl(null);
    confirmAlert({
      title: "Alerta",
      message: acao.message,
      buttons: [
        {
          label: "Sim",
          onClick: () => {
            acao.request(turma).then((data) => {
              if (!data || data.error) {
                errorMessage(data?.message || "Não foi possível iniciar a operação.");
                return;
              }
              successMessage("Operação sendo realizada em segundo plano.");
            });
          },
        },
        { label: "Não", onClick: () => {} },
      ],
    });
  };

  return (
    <Container>
      <Stack direction="row" justifyContent="space-between" alignItems="center" spacing={2} mb={3}>
        <Box>
          <Typography variant="h6">Alunos da Turma</Typography>
          <Typography variant="body2" color="text.secondary">
            {turma
              ? "Matrículas, número de chamada e resultado final dos alunos."
              : "Selecione uma turma para gerenciar os alunos."}
          </Typography>
        </Box>
        {turma && isGestor && (
          <>
            <Tooltip title="Média e resultado final">
              <IconButton onClick={(event) => setAnchorEl(event.currentTarget)}>
                <MoreVertIcon />
              </IconButton>
            </Tooltip>
            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: "top", horizontal: "right" }}
            >
              {GRUPOS_ACOES.flatMap((grupo, i) => [
                i > 0 && <Divider key={`div-${grupo.titulo}`} />,
                <ListSubheader key={grupo.titulo} sx={{ lineHeight: "32px" }}>
                  {grupo.titulo}
                </ListSubheader>,
                ...grupo.acoes.map((acao) => (
                  <MenuItem key={`${grupo.titulo}-${acao.label}`} onClick={() => handleAcao(acao)}>
                    {acao.label}
                  </MenuItem>
                )),
              ]).filter(Boolean)}
            </Menu>
          </>
        )}
      </Stack>

      {turma ? (
        <Stack spacing={3}>
          <TurmaProfileRedux />
          {alunoTurma ? <AlunoTurmaFormContainer /> : <AlunoTurmaTable />}
        </Stack>
      ) : (
        <TurmaTableSelectRedux />
      )}
    </Container>
  );
}
